import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { useCases } from "@/data/use-cases";

export function UseCases() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
      <div className="max-w-2xl">
        <SectionEyebrow>Every Stage of Growth</SectionEyebrow>
        <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          Infrastructure for Every Stage of Growth
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {useCases.map((u) => (
          <div key={u.title} className="rounded-card border border-border bg-navy-card p-6">
            <h3 className="font-display text-base font-semibold text-text-primary">{u.title}</h3>
            <p className="mt-2.5 text-sm leading-relaxed text-text-secondary">{u.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
